import * as React from "react";

import { useLocalization } from "@shared-ui/localization-context";

import { UitkFakeInput } from "uitk-react-input";
import { UitkSpacing } from "uitk-react-spacing";

import { withStores } from "src/stores";

export const SingleSearchEntry: React.FC = withStores("wizardState")(({ children, wizardState }) => {
  const [displayForms, setDisplayForms] = React.useState(false);
  const { formatText } = useLocalization();

  const { labelKey } = wizardState.globalWizardState.config.singleSearchEntryTrigger;
  const label = formatText(labelKey);

  const onSearchForProductsButtonClick = () => {
    setDisplayForms(true);
  };

  return (
    <>
      {!displayForms && (
        <UitkSpacing padding={{ blockstart: "six", blockend: "twelve", inline: "six" }}>
          <div>
            <UitkFakeInput
              onClick={onSearchForProductsButtonClick}
              label={label}
              icon="search"
              id="single-search-entry-trigger"
              data-testid="single-search-entry-trigger"
            />
          </div>
        </UitkSpacing>
      )}

      {displayForms && children}
    </>
  );
});
